export enum CopyLinkType {
  CopyLink = 'Copy Link',
  CopySingleUseLink = 'Copy Single-Use Link',
}
